import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { ContentType } from '@/content/types/content.types';
import { SECTION_OPTIONS_ROOT_TEMPLATES } from '@/content/values/sections';
import { Section } from '@/courses/models/section.model';
import { SectionProvider } from '@/sections/providers/section.provider';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';

@Component({
  name: 'ed-filler-sections',
  components: {
    EdContentSidebarSection: () => import(/* EdContentSidebarSection */'@/sections/components/ed-content-sidebar-section/ed-content-sidebar-section.component.vue'),
  }
})
export default class EdFillerSectionsComponent extends Vue {

  @Prop({ default: null }) readonly contentId: number;
  @Prop({ default: null }) readonly classId: number;
  @Prop({ default: '' }) readonly componentName: string;
  @Prop({ default: COURSE_MODE.VIEWER }) readonly mode: COURSE_MODE;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: () => [] }) readonly sections: Section[];
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: false }) readonly loaded: boolean;
  @Prop({ default: null }) readonly options: EdSectionOptions;
  @Prop({ default: false }) readonly isProject: boolean;

  get isShownWithoutContent(): boolean {
    if (this.mode === COURSE_MODE.VIEWER) {
      return this.fillerSections.length > 0;
    }
    return true;
  }

  get filler(): Section {
    return this.sections.find(
      s => s.fixedSection === 'FILLERS'
    );
  }

  get fillerSections() {
    return this.filler ? this.filler.sections : [];
  }

  get lessonCounter() {
    return SectionProvider.getLessonCounter(this.fillerSections || []);
  }

  get menuAddOptions() {
    if(this.contentType === 'TEMPLATE') {
      return SectionsProvider.getCreateObjMenu([...SECTION_OPTIONS_ROOT_TEMPLATES], this.$i18n);
    }
    return [];
  }

  goToAddFillerSection(minDate: string = null, isCreatingLesson = false) {
    SectionProvider.openLessonCreator(
      this.contentId,
      this.classId,
      this.filler,
      minDate,
      isCreatingLesson,
      'FILLERS'
    );
  }

}